import React, { useMemo } from "react";
import { Table, Column, HeaderCell, Cell } from "rsuite-table";
import "rsuite-table/dist/css/rsuite-table.css";
import { Button, ButtonGroup } from "rsuite";

// Import images from assets
import tataPowerLogo from "../../assets/operators/TTP.png";
import bsesLogo from "../../assets/operators/BSY.png";
import uttarHaryanaLogo from "../../assets/operators/APS.png";
import uttarakhandLogo1 from "../../assets/operators/AEM.png";
import uttarakhandLogo2 from "../../assets/operators/DGE.png";
import uttarakhandLogo3 from "../../assets/operators/IRM.png";

const data = [
  { id: 1, name: "Tata Power", image: tataPowerLogo, caNo: "123456", duedate: "2025-02-15", date: "2025-02-15", amount: 500 },
  { id: 2, name: "BSES", image: bsesLogo, caNo: "789012", duedate: "2025-02-15", date: "2025-02-14", amount: 700 },
  { id: 3, name: "Uttar Haryana", image: uttarHaryanaLogo, caNo: "345678", duedate: "2025-02-15", date: "2025-02-13", amount: 600 },
  { id: 4, name: "Adani Electric", image: uttarakhandLogo1, caNo: "345678", duedate: "2025-02-15", date: "2025-02-13", amount: 800 },
  { id: 5, name: "DGVCL", image: uttarakhandLogo2, caNo: "345678", duedate: "2025-02-15", date: "2025-02-13", amount: 800 },
  { id: 6, name: "BESCOM", image: uttarakhandLogo3, caNo: "345678", duedate: "2025-02-15", date: "2025-02-13", amount: 800 },
];

const BillersView = () => {
  const handleFetchBill = (id) => {
    console.log("Fetching bill for ID:", id);
  };

  const handlePayBill = (id, amount) => {
    console.log(`Paying ₹${amount} for bill ID: ${id}`);
  };

  const columns = useMemo(
    () => [
      { key: "id", label: "Biller ID" },
      { key: "name", label: "Biller Name" },
      { key: "caNo", label: "CA No" },
      { key: "duedate", label: "Due Date" },
      { key: "date", label: "Bill Generated Date" },
      { key: "pay", label: "Actions" },
    ],
    []
  );

  return (
    <div style={{ padding: 20, backgroundColor: "#f5f7fa", borderRadius: 10 }}>
      <h2 style={{ textAlign: "center", color: "#333" }}>My Billers</h2>

      <div style={{ overflowX: "auto", width: "100%" }}>
        <Table
          autoHeight
          data={data}
          bordered
          cellBordered
          hover
          style={{
            minWidth: 800,
            backgroundColor: "#fff",
            borderRadius: 10,
          }}
        >
          {columns.map((col) => (
            <Column key={col.key} flexGrow={col.key === "pay" ? 0 : 1} width={col.key === "pay" ? 220 : undefined} align="left">
              <HeaderCell style={{ backgroundColor: "#007bff", color: "#fff", fontWeight: "bold", textAlign: "left", paddingLeft: 10 }}>
                {col.label}
              </HeaderCell>
              <Cell style={{ backgroundColor: "#eef2f7", textAlign: "left", paddingLeft: 10 }}>
                {(rowData) =>
                  col.key === "name" ? (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <img
                        src={rowData.image}
                        alt={rowData.name}
                        style={{ width: 25, height: 25, objectFit: "contain", borderRadius: "5px" }}
                      />
                      <span>{rowData.name}</span>
                    </div>
                  ) : col.key === "pay" ? (
                    <ButtonGroup style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                      <Button
                        appearance="primary"
                        style={{ backgroundColor: "#17a2b8", border: "none", padding: "5px 8px" }}
                        onClick={() => handleFetchBill(rowData.id)}
                      >
                        Fetch Bill
                      </Button>
                      <Button
                        appearance="primary"
                        style={{ backgroundColor: "#28a745", border: "none", padding: "5px 8px" }}
                        onClick={() => handlePayBill(rowData.id, rowData.amount)}
                      >
                        Pay ₹{rowData.amount}
                      </Button>
                    </ButtonGroup>
                  ) : (
                    rowData[col.key]
                  )
                }
              </Cell>
            </Column>
          ))}
        </Table>
      </div>
    </div>
  );
};

export default BillersView;
